<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">应用订单</span>
      </div>
      <div class="right">
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button type="primary" style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <SeniorSearch :data="columns" @getParams="getParams" />
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data"></Table>
      <div class="t-right" style="margin-top: 10px">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" show-elevator show-sizer
          show-total />
      </div>
    </div>
    <Modal :width="600" title="发票信息" v-model="visible">
      <Form ref="formInline" :model="invoice" :rules="rule" :label-width="100" inline>
        <FormItem prop="name" label="发票抬头:">
          <Input style="width: 160px" v-model="invoice.name" placeholder="发票抬头" />
        </FormItem>
        <FormItem prop="type" label="发票类型:">
          <Select style="width: 160px" v-model="invoice.type" placeholder="发票类型">
            <Option :value="0">个人</Option>
            <Option :value="1">单位</Option>
          </Select>
        </FormItem>
        <FormItem prop="money" label="发票金额:">
          <Input style="width: 160px" v-model="invoice.money" placeholder="发票金额" disabled />
        </FormItem>
        <FormItem prop="email" label="邮箱地址:">
          <Input style="width: 160px" v-model="invoice.email" placeholder="邮箱地址" />
        </FormItem>
        <FormItem prop="code" label="纳税人识别号:" v-if="invoice.type == 1">
          <Input style="width: 260px" v-model="invoice.code" placeholder="纳税人识别号" />
        </FormItem>
        <FormItem prop="log" label="发票备注:">
          <Input style="width: 260px" v-model="invoice.log" placeholder="发票备注" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="visible = false">取消</Button>
        <Button type="primary" @click="createInvoice">确认</Button>
      </div>
    </Modal>

    <Modal :width="400" title="上传发票" v-model="uploadModal">
      <div>
        <Upload multiple type="drag" :action="`https:${config.imgSrc}/print/invoice/upload`" :data="{ id: uploadId }"
          accept="application/pdf" :show-upload-list="false" :format="['pdf']" name="file" :on-format-error="FormatError"
          :on-success="UploadSuccess">
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>单击或拖动文件到此处上传</p>
          </div>
        </Upload>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config'
import SeniorSearch from '_c/senior_search'
import excel from '@/libs/excel'
export default {
  components: {
    SeniorSearch
  },
  data () {
    this.types = {
      1: '12个月设备运维费',
      2: '24个月设备运维费',
      3: '36个月设备运维费',
      4: '刷卡验证',
      5: '身份证自动读取输出功能',
      6: '智能运维运营期',
      7: '人脸识别功能',
      8: '照片冲印',
      9: '钱包充值'
    }
    this.pay_type = {
      1: '微信',
      2: '支付宝',
      3: '对公转账'
    }
    return {
      confirmLoading: true,
      config: config,
      uploadModal: false,
      uploadId: 0,
      invoice: {
        name: '',
        type: 0,
        money: '',
        email: '',
        code: ''
      }, // 发票
      visible: false,
      rule: {
        name: [
          { required: true, message: '请输入发票抬头', trigger: 'change' }
        ],
        type: [
          {
            required: true,
            type: 'number',
            message: '请选择发票类型',
            trigger: 'change'
          }
        ],
        money: [
          {
            required: true,
            type: 'number',
            message: '请输入发票金额',
            trigger: 'change'
          }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入纳税人识别号', trigger: 'change' }
        ]
      },
      page: {
        p: 0,
        l: 10,
        search: {}
      },
      total: 0,
      data: [],
      columns: [
        { key: 'id', width: 80, title: '编号', search: true },
        {
          key: 'create_time',
          width: 135,
          title: '下单时间',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          },
          search: true
        },
        { key: 'out_trade_no', width: 150, title: '支付单号', search: true },
        {
          key: 'sn',
          width: 150,
          title: '设备序列号',
          search: true,
          render: (h, data) => {
            return h('span', {}, data.row.sns.join(','))
          }
        },
        {
          key: 'types',
          title: '增值功能',
          width: 150,
          render: (h, data) => {
            let temp = []
            data.row.types.split(',').map((item) => {
              temp.push(this.types[item])
            })
            return h('span', {}, temp.join(','))
          },
          search: true
        },
        { key: 'money', width: 80, title: '金额', search: true },

        {
          key: 'pay_type',
          width: 110,
          title: '支付方式',
          render: (h, data) => {
            let imgsArr = [], imgsArr1 = []
            let imgs = data.row.src ? data.row.src.split(',') : []
            imgs.map(item => {
              imgsArr.push(h(
                'Tooltip',
                {
                  props: { placement: 'left' }
                },
                [
                  h(
                    'img',
                    {
                      style: { width: '100%' },
                      slot: 'content',
                      attrs: { src: `${config.imgSrc}${item}` }
                    },
                    ''
                  ),
                  h('Icon', {
                    props: { type: 'md-image' },
                    style: {
                      display: data.row.pay_type === 3 ? 'inline' : 'none',
                      marginLeft: '5px',
                      fontSize: '16px',
                      lineHeight: '1px',
                      color: '#2db7f5',
                      cursor: 'pointer'
                    }
                  })
                ]

              ))

              imgsArr1.push(h(
                'img',
                {
                  style: { width: '100%' },
                  slot: 'content',
                  attrs: { src: `${config.imgSrc}${item}` }
                },
                ''
              ))
            })
            console.log('支付方式', this.pay_type[data.row.pay_type])
            return h('span', {}, [
              h('span', {}, this.pay_type[data.row.pay_type]),
              // imgsArr,
              h(
                'Tooltip',
                {
                  props: { placement: 'left' }
                },
                // imgsArr,
                [
                  imgsArr1,
                  // h(
                  //   "img",
                  //   {
                  //     style: { width:F "100%" },
                  //     slot: "content",
                  //     attrs: { src: `${config.imgSrc}${data.row.src}` },
                  //   },
                  //   ""
                  // ),
                  h('Icon', {
                    props: { type: 'md-image' },
                    style: {
                      display: data.row.pay_type === 3 ? 'inline' : 'none',
                      marginLeft: '5px',
                      fontSize: '16px',
                      lineHeight: '1px',
                      color: '#2db7f5',
                      cursor: 'pointer'
                    }
                  })
                ]

              )
            ])
            // return h("span",{},this.pay_type[data.row.pay_type])
          },
          search: true
        },
        { key: 'agent_name', width: 200, title: '合作伙伴', search: true },
        { key: 'company_name', width: 100, title: '企业名称', search: true },
        { key: 'remark', width: 200, title: '备注' },
        {
          key: 'is_invoice',
          width: 100,
          title: '开票状态',
          render: (h, data) => {
            let name = '',
              color = ''
            if (data.row.is_invoice === 0) {
              name = '未开'
              color = '#ed4014'
            } else if (data.row.is_invoice === 1) {
              name = '开票中'
              color = '#ff9900'
            } else if (data.row.is_invoice === 2) {
              name = '已开票'
              color = '#19be6b'
            }
            return h('span', { style: { color: color } }, name)
          },
          search: true,
          searchOption: {
            type: 'select',
            vals: [
              { name: '未开', val: 0 },
              { name: '开票中', val: 1 },
              { name: '已开票', val: 2 }
            ]
          }
        },
        {
          key: 'used',
          width: 100,
          title: '是否生效',
          render: (h, data) => {
            return h(
              'span',
              { style: { color: data.row.used ? '#19be6b' : '#ed4014' } },
              data.row.used ? '已生效' : '未生效'
            )
          },
          search: true,
          searchOption: {
            type: 'select',
            vals: [
              { name: '未生效', val: 0 },
              { name: '已生效', val: 1 }
            ]
          }
        },
        {
          key: 'pay_status',
          width: 100,
          title: '订单状态',
          render: (h, data) => {
            return h(
              'span',
              {
                style: {
                  color:
                    data.row.pay_status === 1 ||
                      (data.row.pay_type === 3 && data.row.src && data.row.used)
                      ? '#19be6b'
                      : !data.row.pay_status &&
                        data.row.pay_type === 3 &&
                        data.row.src
                        ? '#ed4014'
                        : '#ed4014'
                }
              },
              data.row.pay_status === 1 ||
                (data.row.pay_type === 3 && data.row.src && data.row.used)
                ? '已完成'
                : !data.row.pay_status &&
                  data.row.pay_type === 3 &&
                  data.row.src
                  ? '待审核'
                  : data.row.pay_status === 2
                    ? '已驳回'
                    : '已取消'
            )
          },
          search: true,
          searchOption: {
            type: 'select',
            vals: [
              { name: '未支付', val: 0 },
              { name: '已支付', val: 1 },
              { name: '已驳回', val: 2 }
            ]
          }
        },
        { key: 'reason', width: 200, title: '驳回原因' }
      ],
      company: {},
      machine: {}
    }
  },
  mounted () {
    this.getData()
    this.columns.push({
      key: 'operate',
      title: '操作',
      export_ignore: true,
      width: 150,
      fixed: 'right',
      render: (h, data) => {
        let temp = []
        if (
          !data.row.used &&
          !this.agent.tp &&
          !data.row.pay_status &&
          data.row.pay_type === 3
        ) {
          temp.push(
            h(
              'Button',
              {
                props: { size: 'small', type: 'success' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    if (data.row.types == 6) {
                      this.meterIncrementApply(data.row)
                    } else {
                      this.incrementApply(data.row)
                    }
                  }
                }
              },
              '通过审核'
            )
          )

          temp.push(
            h(
              'Button',
              {
                props: { size: 'small', type: 'warning' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.initDismiss(data.row.id)
                  }
                }
              },
              '驳回'
            )
          )
        }
        if (
          !data.row.is_invoice &&
          data.row.used &&
          this.agent.tp &&
          data.row.pay_status === 1
        ) {
          temp.push(
            h(
              'Button',
              {
                props: { size: 'small', type: 'success' },
                on: {
                  click: () => {
                    let log = '设备:'
                    if (!this.agent.tp) {
                      this.getAgentInfo(data.row.agent_id).then((res) => {
                        this.visible = true
                        this.invoice.name = res.agent_name
                        this.invoice.type = 1
                        this.invoice.money = data.row.money
                        this.invoice.email = res.email
                        this.invoice.agent_id = data.row.agent_id
                        this.invoice.increment_id = data.row.id
                      })
                    } else {
                      this.visible = true
                      this.invoice.name = this.agent.name
                      this.invoice.type = 1
                      this.invoice.money = data.row.money
                      this.invoice.email = this.agent.email
                      this.invoice.agent_id = data.row.agent_id
                      this.invoice.increment_id = data.row.id
                    }
                    let ma = [],
                      tps = []
                    data.row.machine_id.split(',').map((item) => {
                      ma.push(this.machine[item])
                    })
                    data.row.types.split(',').map((item) => {
                      tps.push(this.types[item])
                    })
                    log += ma.join(',') + ' --- 购买:' + tps.join(',')
                    this.invoice.log = log
                  }
                }
              },
              this.agent.tp ? '申请开票' : '开票'
            )
          )
        }

        if (!this.agent.tp && data.row.used && data.row.is_invoice === 1) {
          temp.push(
            h(
              'Button',
              {
                props: { size: 'small', type: 'success' },
                on: {
                  click: () => {
                    this.uploadModal = true
                    this.uploadId = data.row.invoice_id
                  }
                }
              },
              '开票'
            )
          )
        }

        if (
          !data.row.used &&
          data.row.pay_status === 0 &&
          data.row.pay_type !== 3
        ) {
          let btn = h(
            'Button',
            {
              props: { size: 'small', type: 'error' },
              on: {
                click: () => {
                  this.IncrementDelete({ id: data.row.id }).then((res) => {
                    this.$Message[res.status ? 'success' : 'error'](res.msg)
                    res.status && this.getData()
                  })
                }
              }
            },
            '删除'
          )
          temp.push(btn)
          // if (this.agent.tp && data.row.pay_type !== 3) temp.push(btn);
          // else if (!this.agent.tp && data.row.pay_type !== 3) temp.push(btn);
        }

        if (this.agent.tp && data.row.used && data.row.is_invoice === 2) {
          temp.push(
            h(
              'Button',
              {
                props: { size: 'small', type: 'success' },
                on: {
                  click: () => {
                    window.open(data.row.invoice_src)
                  }
                }
              },
              '下载发票'
            )
          )
        }
        return h(
          'div',
          {
            style: {
              width: '85px',
              display: 'flex',
              justifyContent: 'space-between'
            }
          },
          temp
        )
      }
    })
  },
  methods: {
    FormatError () {
      this.$Message.error('文件格式错误')
    },
    initDismiss (id, reason = '') {
      // DismissIncrement
      this.$Modal.confirm({
        loading: this.confirmLoading,
        title: '驳回',
        render: (h) => {
          return h('Input', {
            props: {
              autofocus: true,
              value: reason,
              placeholder: '请填写驳回原因'
            },
            on: {
              input: (val) => {
                reason = val
              }
            }
          })
        },
        onOk: () => {
          console.log('this.confirmLoading', this.confirmLoading)
          if (!reason) {
            this.$Message.error('请填写驳回原因')
            this.$Modal.remove()
            setTimeout(() => {
              this.initDismiss(id, reason)
            }, 300)
            return false
          }
          this.DismissIncrement({ id, reason }).then((res) => {
            this.$Modal.remove()
            if (!res.status) {
              this.$Message.error(res.msg)
              setTimeout(() => {
                this.initDismiss(id, reason)
              }, 300)
              return false
            }
            this.$Message.success(res.msg)
            this.getData()
          })
          console.log('reason', reason)
        }
      })
    },
    UploadSuccess () {
      this.$Message.success('上传发票成功，邮件已发送')
      this.uploadModal = false
      this.getData()
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '增值订单'
      }
      this.columns.map((item) => {
        if (item.export_ignore) {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        let cond = JSON.parse(JSON.stringify(this.page))
        cond.l = 100000
        cond.p = 0
        this.GetIncrement(cond).then((res) => {
          params.data = this.formatExportData(res.data)
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.formatExportData(this.data)
        excel.export_array_to_excel(params)
      }
    },
    formatExportData (data) {
      data = JSON.parse(JSON.stringify(data))
      data.map((item) => {
        let temp = []
        item.types.split(',').map((it) => {
          temp.push(this.types[it])
        })
        item.types = temp.join(',')
        item.pay_type = this.pay_type[item.pay_type]
        item.create_time = this.$moment(item.bind_time)
        item.is_invoice = item.is_invoice
          ? item.is_invoice === 1
            ? '开票中'
            : '已开票'
          : '未开'
        item.used = item.used ? '已生效' : '未生效'
        item.pay_status =
          item.pay_status === 1 ||
            (item.pay_type === 3 && item.src && item.used)
            ? '已完成'
            : !item.pay_status && item.pay_type === 3 && item.src
              ? '待审核'
              : item.pay_status === 2
                ? '已驳回'
                : '已取消'
      })
      return data
    },
    getParams (cond) {
      this.page.search = cond
      this.getData()
    },
    createInvoice () {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.invoice))
          console.log(data)
          delete data.agent_id
          if (data.type < 1) delete data.code
          if (!this.agent.tp) {
            data.agent_id = this.agent_id
          }
          this.CreateInvoice({ data: data, id: data.increment_id }).then(
            (res) => {
              if (res) {
                this.visible = false
                this.invoice = {
                  name: '',
                  type: 0,
                  money: '',
                  email: '',
                  code: ''
                }
                this.getData()
              }
            }
          )
        }
      })
    },
    meterIncrementApply (data) {
      this.MeterIncrementApply({ id: data.id }).then((res) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    incrementApply (data) {
      this.IncrementApply(data).then((res) => {
        if (res) {
          data.used = 1
          this.$Message.success('操作成功')
        }
      })
    },
    getData () {
      this.GetIncrement(this.page).then((res) => {
        this.data = res.data
        this.total = res.total
        this.company = res.company
        this.machine = res.machine
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    ...mapActions([
      'GetIncrement',
      'IncrementApply',
      'CreateInvoice',
      'getAgentInfo',
      'MeterIncrementApply',
      'IncrementDelete',
      'DismissIncrement'
    ])
  },
  computed: mapGetters({
    agent: 'agent'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
